import { createRoot } from 'react-dom/client'
import App from './App';
import './site.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
